import { render } from "./indexPM.vue?vue&type=template&id=130dad45"
import script from "./indexPM.vue?vue&type=script&lang=js"
export * from "./indexPM.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__